import {jsonMember, jsonObject} from "typedjson";

/** Структура «Код бюджетной классификации» */

@jsonObject
export class PitFinancingItem {

  /** Уникальный идентификатор записи КБК */
  @jsonMember({name: "id", constructor: Number, emitDefaultValue: false, isRequired: false })
  private _id: number;

  @jsonMember({name: "financingItemId", constructor: Number, emitDefaultValue: false, isRequired: false })
  private _financingItemId: number;

  /** Уровень бюджета */
  @jsonMember({name: "budgetLevelId", constructor: Number, emitDefaultValue: false, isRequired: false })
  private _budgetLevelId: number;

  /** Тип нормирования 1 - норматив, 2 - сверхнорматив, 3 - субсидия */
  @jsonMember({name: "normTypeId", constructor: Number, emitDefaultValue: false, isRequired: false })
  private _normTypeId: number;

  /** Код главного администратора доходов бюджета (КАДМ) */
  @jsonMember({name: "kadmId", constructor: Number, emitDefaultValue: false, isRequired: false })
  private _kadmId: number;

  @jsonMember({name: "kadmCode", constructor: String, emitDefaultValue: false, isRequired: false })
  private _kadmCode: string;

  /** Код функциональной структуры расходов (КФСР) */
  @jsonMember({name: "kfsrId", constructor: Number, emitDefaultValue: false, isRequired: false })
  private _kfsrId: number;
  @jsonMember({name: "kfsrCode", constructor: String, emitDefaultValue: false, isRequired: false })
  private _kfsrCode: string;

  /** Код целевой статьи расходов (КЦСР) */
  @jsonMember({name: "kcsrId", constructor: Number, emitDefaultValue: false, isRequired: false })
  private _kcsrId: number;
  @jsonMember({name: "kcsrCode", constructor: String, emitDefaultValue: false, isRequired: false })
  private _kcsrCode: string;

  /** Код вида расходов (КВР) */
  @jsonMember({name: "kvrId", constructor: Number, emitDefaultValue: false, isRequired: false })
  private _kvrId: number;

  @jsonMember({name: "kvrCode", constructor: String, emitDefaultValue: false, isRequired: false })
  private _kvrCode: string;

  /** Код операции сектора государственного управления (КОСГУ) */
  @jsonMember({name: "kosguId", constructor: Number, emitDefaultValue: false, isRequired: false })
  private _kosguId: number;

  @jsonMember({name: "kosguCode", constructor: String, emitDefaultValue: false, isRequired: false })
  private _kosguCode: string;

  /** Дополнительный функциональный код (Доп. ФК) */
  @jsonMember({name: "dopFkId", constructor: Number, emitDefaultValue: false, isRequired: false })
  private _dopFkId: number;

  @jsonMember({name: "dopFkCode", constructor: String, emitDefaultValue: false, isRequired: false })
  private _dopFkCode: string;

  /** Дополнительный экономический код (Доп. ЭК) */
  @jsonMember({name: "dopEkId", constructor: Number, emitDefaultValue: false, isRequired: false })
  private _dopEkId: number;

  @jsonMember({name: "dopEkCode", constructor: String, emitDefaultValue: false, isRequired: false })
  private _dopEkCode: string;

  /** Дополнительный код расходов (Доп. КР) */
  @jsonMember({name: "dopKrId", constructor: Number, emitDefaultValue: false, isRequired: false })
  private _dopKrId: number;

  @jsonMember({name: "dopKrCode", constructor: String, emitDefaultValue: false, isRequired: false })
  private _dopKrCode: string;


  get id(): number {
    return this._id ? this._id : this._financingItemId;
  }

  set id(value: number) {
    this._id = value;
  }

  get financingItemId(): number {
    return this._financingItemId ? this._financingItemId : this._id;
  }

  set financingItemId(value: number) {
    this._financingItemId = value;
  }


  get kadmId(): number {
    return this._kadmId;
  }

  set kadmId(value: number) {
    this._kadmId = value;
  }

  get kfsrId(): number {
    return this._kfsrId;
  }

  set kfsrId(value: number) {
    this._kfsrId = value;
  }

  get kcsrId(): number {
    return this._kcsrId;
  }

  set kcsrId(value: number) {
    this._kcsrId = value;
  }

  get kvrId(): number {
    return this._kvrId;
  }

  set kvrId(value: number) {
    this._kvrId = value;
  }

  get kosguId(): number {
    return this._kosguId;
  }

  set kosguId(value: number) {
    this._kosguId = value;
  }

  get dopFkId(): number {
    return this._dopFkId;
  }

  set dopFkId(value: number) {
    this._dopFkId = value;
  }

  get dopEkId(): number {
    return this._dopEkId;
  }

  set dopEkId(value: number) {
    this._dopEkId = value;
  }

  get dopKrId(): number {
    return this._dopKrId;
  }

  set dopKrId(value: number) {
    this._dopKrId = value;
  }

  get budgetLevelId(): number {
    return this._budgetLevelId;
  }

  set budgetLevelId(value: number) {
    this._budgetLevelId = value;
  }

  get kadmCode(): string {
    return this._kadmCode;
  }

  set kadmCode(value: string) {
    this._kadmCode = value;
  }

  get kfsrCode(): string {
    return this._kfsrCode;
  }

  set kfsrCode(value: string) {
    this._kfsrCode = value;
  }

  get kcsrCode(): string {
    return this._kcsrCode;
  }

  set kcsrCode(value: string) {
    this._kcsrCode = value;
  }

  get kvrCode(): string {
    return this._kvrCode;
  }

  set kvrCode(value: string) {
    this._kvrCode = value;
  }

  get kosguCode(): string {
    return this._kosguCode;
  }

  set kosguCode(value: string) {
    this._kosguCode = value;
  }

  get dopFkCode(): string {
    return this._dopFkCode;
  }

  set dopFkCode(value: string) {
    this._dopFkCode = value;
  }

  get dopEkCode(): string {
    return this._dopEkCode;
  }

  set dopEkCode(value: string) {
    this._dopEkCode = value;
  }

  get dopKrCode(): string {
    return this._dopKrCode;
  }

  set dopKrCode(value: string) {
    this._dopKrCode = value;
  }

  get normTypeId(): number {
    return this._normTypeId;
  }

  set normTypeId(value: number) {
    this._normTypeId = value;
  }


  constructor(fields?:Partial<PitFinancingItem>) {
    if (fields) {
      Object.assign(this, fields);
    }
  }
}
